import { render, staticRenderFns } from "./SubfamilyWholesaleDiscountsShowEdit.vue?vue&type=template&id=45d1a72a&lang=pug&"
import script from "./SubfamilyWholesaleDiscountsShowEdit.vue?vue&type=script&lang=js&"
export * from "./SubfamilyWholesaleDiscountsShowEdit.vue?vue&type=script&lang=js&"
import style0 from "./SubfamilyWholesaleDiscountsShowEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SubfamilyWholesaleDiscountsShowEdit.vue"
export default component.exports